import { useHomeBanner, useServiceAIMarkingWizard} from '@/src/api/getData';
import Banner from '@/components/banner';
import Card from '@/components/card';
import DynamicContent from '@/components/dynamicContent';

const ITechMarkingWizardView: any = ({ language = '' }) => {
    const { data: banner } = useHomeBanner(language);
    const { data: markingWizard } = useServiceAIMarkingWizard(language);
    let markingWizardData = markingWizard?.data || {};
    
    return (
        <main className='bg-2' id="start">
            <Banner banner={banner} category="AI Marking Wizard" />
            <Card cardData={markingWizardData?.Card_video?.Cards || []} cardType="orange-card"/>
            <DynamicContent content={markingWizardData?.Content} />
        </main>
    );
}

export default ITechMarkingWizardView;